import React from "react";

import PropTypes from 'prop-types';

import TerminalNameTerminal from './TerminalNameNode';

const BaseMixin = {
  propTypes: {
    node: PropTypes.object,
    editable: PropTypes.bool,
    metaData: PropTypes.object
  },

  getDefaultProps: function() {
    return {
      editable: true,
      metaData: {}
    };
  },

  renderTerminalName: function(name) {
    return <TerminalNameTerminal metaData={this.props.metaData} node={this.props.node} remove={this.props.remove} displayName={name} editable={this.props.editable} />;
  },

  terminalName: function() {
    return this.props.node.get('terminal');
  },

  _renderReadonlyValue: function(value) {
    return (
      <div className="form-control readonly-value">{value}</div>
    );
  }
};

export default BaseMixin;
